module.exports = __webpack_public_path__ + "img/suitability.c826d4d5.svg";